module.exports = __webpack_public_path__ + "media/images/social/fb-dark-bd9c3f7b1bc84c1cc28ee2ef46463fb8.svg";